export default "__VITE_ASSET__DQb$oM1B__"